<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'CheckButtonGroup',
    componentName: 'CheckButtonGroup',
    props: {
      value: {}
    }
  }
</script>

<style scoped>

</style>
